import {
  TestImapConnectionDocument,
  type TestImapConnectionMutation,
  type TestImapConnectionMutationVariables,
} from "@src/__generated__/graphql";
import type { WorkspaceSettingsQuery } from "@src/__generated__/urql-graphql";
import { MutationHelper } from "@src/helpers/apollo/mutation";
import type { AppStore } from "@src/stores/AppStore";
import { action, computed, makeObservable } from "mobx";
import type { ExpenseInboxIntegrationState } from "../forms/SettingsModalState/expense-inbox-integration-state";

export class ExpenseInboxIntegrationStore {
  private testMutator = new MutationHelper<
    TestImapConnectionMutation,
    TestImapConnectionMutationVariables
  >(TestImapConnectionDocument);

  constructor(
    private appStore: AppStore,
    public form: ExpenseInboxIntegrationState,
  ) {
    makeObservable(this);
  }

  @computed
  get isLoadingImapTest() {
    return this.testMutator.isLoading.value;
  }

  @action.bound
  init(data: WorkspaceSettingsQuery) {
    if (!data.workspaceAutoExpenseEmailSettings) return;
    this.form.init(data.workspaceAutoExpenseEmailSettings);
  }

  @action.bound
  async testImapConnection() {
    const [data, error] = await this.testMutator.mutate();

    if (error) return;

    this.appStore.UIStore.toast({
      title: data.testWorkspaceAutoExpenseEmail,
    });
  }
}
